import { render } from "./CustomLinkEdit.vue?vue&type=template&id=756fefa6"
import script from "./CustomLinkEdit.vue?vue&type=script&lang=js"
export * from "./CustomLinkEdit.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__